<app-menu class="menuApp"></app-menu>
<div class="main">

  <div style="padding-top: 2vh">

    <div *ngIf="user.getPermiso() != 'Ateneo'" class="row" style="margin: auto; width: 90%; text-align: center">
      <button id="uploadFloorplanButton" class="btn buttonCst marginAuto" (click)="openUploadFloorplan()">
        <h3 class="textS+ marginAuto">{{this.localiser.get('select_floorplans.uploadButton')}}</h3>
        <span class="material-icons-outlined textXM" style="width: 9%; margin: 0 1%;">
          file_upload
        </span>
      </button>
    </div>

    <div class="row planoSection">
      <div class="planoHeader">
        <h1 class="centerVert textXXM">{{this.localiser.get('select_floorplans.title')}}</h1>
      </div>
      <div class="planoTable">
        <table *ngIf="planos.length > 0" style="width:100%">
          <tr class="bottom-border">
            <th *ngIf="user.getPermiso() != 'Ateneo'"></th>
            <th style="width: 40%" class="textS+">{{this.localiser.get('select_floorplans.name')}}</th>
            <th style="width: 40%" class="textS+">{{this.localiser.get('select_floorplans.description')}}</th>
            <th></th>
            <th></th>
          </tr>
          <tr *ngFor="let plano of planos" class="bottomBorderRow">
            <td *ngIf="user.getPermiso() != 'Ateneo'">
              <span (click)="goToInfoPlano(plano)" style="margin: 1vh auto" class="material-icons-outlined marginAuto textM linkIcon">
                info
              </span>
            </td>
            <td class="textS+">{{plano.nombre}}</td>
            <td class="textS+">{{plano.descripcion}}</td>
            <td (click)="selectPlano(plano)" class="link textS+">{{this.localiser.get('select_floorplans.selectionButton')}}</td>
            <td><span *ngIf="user.getPermiso() != Roles.Ateneo" (click)="deleteFloorplan(plano)" class="textXM material-icons-outlined deleteIcon verticalAlign">delete</span></td>
          </tr>
        </table>
        <div *ngIf="planos.length <= 0" class="noFloorplanText">
          <h3 class="textM">{{this.localiser.get('select_floorplans.noFloorplans')}}</h3>
        </div>
      </div>
    </div>


    <div class="row">

      <div class="paginationDiv">
        <div class="row" style="width: 70%; display: contents">
          <div class="col" style="padding: 0">
              <span (click)="changePageByArrow(-1)" class="material-icons-outlined textXM centerVert cursorPointer navigateBefore"
                    [ngClass]="{disabled: actualPage == 1}">
                navigate_before
              </span>
          </div>
          <div class="col" style="padding: 0">
            <input type="number" class="inputPagination textXM centerVert" [(ngModel)]="this.actualPage" (ngModelChange)="changePageByNumber($event)"
                   (change)="outInputChangePageByNumber($event)">
          </div>
          <div class="col" style="padding: 0">
              <span (click)="changePageByArrow(1)" class="material-icons-outlined textXM centerVert cursorPointer navigateAfter"
                    [ngClass]="{disabled: isLastPage()}">
                navigate_next
              </span>
          </div>
        </div>
      </div>

    </div>

    <div class="row" *ngIf="loadingPlanos">
      <mat-progress-spinner style="margin: 1vh auto; text-align: center;" mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>

  </div>
</div>
